import { useQuery } from '@tanstack/react-query'

import type {
  AdminAccountPreviewModel,
  AdminCarrierPreviewModel,
  AdminLoadPreviewModel,
} from '@fv/models/admin'

import { adminFetch } from '@/utils'

type EntityPreviewModels = {
  account: AdminAccountPreviewModel
  carrier: AdminCarrierPreviewModel
  load: AdminLoadPreviewModel
}

export type EntityPreviewType = keyof EntityPreviewModels

const entityPreviewPaths: Record<EntityPreviewType, (id: string) => string> = {
  account: id => `/preview/accounts/${id}`,
  carrier: id => `/preview/carriers/${id}`,
  load: id => `/preview/loads/${id}`,
}

export const entityPreviewQueryKeys = {
  all: ['entity-preview'] as const,
  entity: (type: EntityPreviewType, id?: string) =>
    [...entityPreviewQueryKeys.all, type, ...(id ? [id] : [])] as const,
}

export function useEntityPreview<T extends EntityPreviewType>(
  type: T,
  id?: string,
  enabled = true,
) {
  return useQuery({
    queryKey: entityPreviewQueryKeys.entity(type, id),
    queryFn: () =>
      adminFetch<EntityPreviewModels[T]>(entityPreviewPaths[type](id!)),
    enabled: !!id && enabled,
    staleTime: Infinity,
  })
}
